import { getHeaders } from './localStorage';
import axios from 'axios';
import { api, versao } from '../config';
import errorHandling from './errorHandling';
import { GET_ENTREGADORES } from './types';

export const getEntregadores = (loja) => {
	return function (dispatch) {
		return axios.get(`${api}/${versao}/api/entregadores?loja=${loja}`, getHeaders())
			.then(response => {
				dispatch({ type: GET_ENTREGADORES, payload: response.data });
				return response.data;
			})
			.catch(errorHandling);
	};
};

export const createEntregador = (loja, body) => {
	return function (dispatch) {
		return axios.post(`${api}/${versao}/api/entregadores?loja=${loja}`, body, getHeaders())
			.then(response => {
				dispatch(getEntregadores(loja));
				return response.data;
			})
			.catch(errorHandling);
	};
};

export const createEntregadoresLote = (loja, itens) => {
	return function (dispatch) {
		return axios.post(`${api}/${versao}/api/entregadores/lote?loja=${loja}`, { itens }, getHeaders())
			.then(response => {
				dispatch(getEntregadores(loja));
				return response.data;
			})
			.catch(errorHandling);
	};
};

export const updateEntregador = (loja, id, body) => {
	return function (dispatch) {
		return axios.put(`${api}/${versao}/api/entregadores/${id}?loja=${loja}`, body, getHeaders())
			.then(response => {
				dispatch(getEntregadores(loja));
				return response.data;
			})
			.catch(errorHandling);
	};
};

export const desativarEntregador = (loja, id) => {
	return function (dispatch) {
		return axios.delete(`${api}/${versao}/api/entregadores/${id}?loja=${loja}`, getHeaders())
			.then(response => {
				dispatch(getEntregadores(loja));
				return response.data;
			})
			.catch(errorHandling);
	};
};
